import React from 'react';
import { InfoRegular } from '@fluentui/react-icons';
import { useTranslation } from 'react-i18next';
import { useCaterersPanelStyles } from './CaterersPanel.styles';
import { iconSize } from '@/theme/scalingTokens';
import type { Caterer } from '@store/models/buildings/entities';

export interface CaterersPanelProps {
  caterers: Caterer[];
}

export const CaterersPanel: React.FC<CaterersPanelProps> = ({ caterers }) => {
  const { t } = useTranslation('bookingForm');
  const styles = useCaterersPanelStyles();

  if (caterers.length === 0) return null;

  return (
    <div
      className={styles.container}
      role="region"
      aria-label={t('bookingForm.catering.ariaLabel')}
    >
      <InfoRegular className={styles.icon} style={{ fontSize: iconSize(16) }} />
      <span className={styles.text}>
        {t('bookingForm.catering.tipPrefix')}{' '}
        {caterers.map((caterer, index) => (
          <React.Fragment key={caterer.name}>
            {index > 0 && ' '}
            <a
              href={caterer.link}
              target="_blank"
              rel="noopener noreferrer"
              className={styles.link}
            >
              {caterer.name}
            </a>
            {index < caterers.length - 1 ? ',' : '.'}
          </React.Fragment>
        ))}
      </span>
    </div>
  );
};

CaterersPanel.displayName = 'CaterersPanel';
